import { parseFilters } from "components/events/fetchEvents";
import { categoryKey } from "security-app/components/SecurityEvents/Alerts/Constants";
const parseRiskScoreRange = (filters) => {
  var _a;
  const rangeValue = (_a = filters.get("scores")) == null ? void 0 : _a[0];
  if (!rangeValue) {
    return void 0;
  }
  const parsedRange = rangeValue.split("-").map((value) => Number(value)).filter((value) => Number.isFinite(value));
  return parsedRange.length > 0 ? parsedRange : void 0;
};
const parseSecurityEventFilters = (filters, defaultTimerange) => {
  const result = parseFilters(filters, defaultTimerange);
  const riskScoreRange = parseRiskScoreRange(filters);
  const filter = {
    associated_assets: filters.get("associated_assets", []),
    mitre_categories: filters.get(categoryKey, []),
    owner: filters.get("owner", []),
    status: filters.get("status", []),
    event_definition_types: filters.get("event_definition_type", []),
    risk_score_range: riskScoreRange,
    associated_investigations: filters.get("associated_investigations", []),
    event_ids: filters.get("event_ids", []),
    tags: filters.get("tags", [])
  };
  const { extra_filters: _extraFilters, ...filterWithoutExtraFilters } = result.filter;
  return {
    ...result,
    filter: {
      priority: [],
      event_definitions: [],
      ...filterWithoutExtraFilters,
      ...filter
    }
  };
};
export default parseSecurityEventFilters;
